import { Route, NavigationGuardNext } from "vue-router";

export const TransitionsResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	// actions.push();
	await Promise.all(actions);
	next();
};
